import {
  AbsencePeriod,
  AbsencePeriodStat,
  AbsencePeriodUser,
  Address,
  Attendance,
  BookingExtendedView,
  BookingView,
  BookingPaymentTerms,
  Convo,
  ConvoMessage,
  ConvoUser,
  ConvoUserView,
  Event,
  EventAttachment,
  EventAudit,
  EventCoHost,
  EventFeedback,
  EventFeedbackAnonymousView,
  EventHostView,
  EventProfile,
  EventSeriesReconciliationAudit,
  FeedbackForm,
  FeedbackFormQuestion,
  Institution,
  InstitutionGroup,
  InstitutionGroupAttachment,
  InstitutionGroupBookingView,
  InstitutionGroupEvent,
  InstitutionGroupEventView,
  InstitutionGroupMember,
  InstitutionGroupMemberView,
  InstitutionGroupTimeLabel,
  InstitutionMember,
  InstitutionMemberInvite,
  InstitutionMemberView,
  InstitutionParent,
  InstitutionProposal,
  InstitutionView,
  LivestreamSession,
  MetricView,
  OrgUnit,
  OrgUnitEvent,
  OrgUnitEventView,
  OrgUnitMember,
  OrgUnitMemberView,
  OutboundEmail,
  PaymentAnnualSummaryView,
  PaymentIn,
  PaymentOut,
  PaymentSummaryView,
  Person,
  ReportEventView,
  ReportGroupUserView,
  ReportInstitutionGroupView,
  ReportInstitutionView,
  ReportUserView,
  Specialty,
  TaskDefnView,
  TaskGroupView,
  TaskUserView,
  TaskUserGroupView,
  Ticket,
  TicketBooking,
  User,
  UserView,
  VoucherCode,
  VoucherProduct,
  WorkflowView,
} from 'cb-model';
import { Timetable, TimetableGroup, TimetableSession, TimetableConversation } from 'timetable-model';
import { setReduxEntities } from 'gossamer-front-end';
import { deepFreezeEntities, FieldType, ReferenceField } from 'gossamer-unified';
import { Task, TaskDefinition, Transaction, TransRow, TransRowView } from 'gossamer-model';
import { UneditableRagStatus, UneditableReferenceUser } from 'cb-front-end';
import { PercentageBar } from 'shared-front-end';

export const ENTITIES = [
  AbsencePeriod,
  AbsencePeriodStat,
  AbsencePeriodUser,
  Address,
  Attendance,
  BookingExtendedView,
  BookingView,
  BookingPaymentTerms,
  Convo,
  ConvoMessage,
  ConvoUser,
  ConvoUserView,
  Event,
  EventAttachment,
  EventAudit,
  EventCoHost,
  EventFeedback,
  EventFeedbackAnonymousView,
  EventHostView,
  EventProfile,
  EventSeriesReconciliationAudit,
  FeedbackForm,
  FeedbackFormQuestion,
  Institution,
  InstitutionGroup,
  InstitutionGroupAttachment,
  InstitutionGroupBookingView,
  InstitutionGroupEvent,
  InstitutionGroupEventView,
  InstitutionGroupMember,
  InstitutionGroupMemberView,
  InstitutionGroupTimeLabel,
  InstitutionMember,
  InstitutionMemberInvite,
  InstitutionMemberView,
  InstitutionParent,
  InstitutionProposal,
  InstitutionView,
  LivestreamSession,
  MetricView,
  OrgUnit,
  OrgUnitEvent,
  OrgUnitEventView,
  OrgUnitMember,
  OrgUnitMemberView,
  OutboundEmail,
  PaymentAnnualSummaryView,
  PaymentIn,
  PaymentOut,
  PaymentSummaryView,
  Person,
  ReportEventView,
  ReportGroupUserView,
  ReportInstitutionGroupView,
  ReportInstitutionView,
  ReportUserView,
  Specialty,
  Task,
  TaskDefinition,
  TaskDefnView,
  TaskGroupView,
  TaskUserView,
  TaskUserGroupView,
  Ticket,
  TicketBooking,
  Transaction,
  TransRow,
  TransRowView,
  User,
  UserView,
  VoucherCode,
  VoucherProduct,
  WorkflowView,
  // Timetable entities
  Timetable,
  TimetableGroup,
  TimetableSession,
  TimetableConversation,
];

// Link to User page if role is staff or admin, otherwise just show name and email, without a link
BookingView.fields.user_id.renderUneditable = UneditableReferenceUser;

// RAG Status coloured circle
AbsencePeriodUser.fields.rag_status.renderUneditable = UneditableRagStatus;

// Percentage Bar
TaskDefnView.fields.completed_percentage.renderUneditable = PercentageBar;
WorkflowView.fields.completed_percentage.renderUneditable = PercentageBar;

Task.fields.assigned_to.type = FieldType.Reference;
(Task.fields.assigned_to as ReferenceField).refEntity = User;

deepFreezeEntities(ENTITIES);
setReduxEntities(ENTITIES);
